import { store } from "@betacrew/jars-flux";
import { componentKey, setBuyPlan, setHasEnoughRequests, setLoadingState, setW8Forms, setW8W9Fees, setW8W9FormsModal, setW8W9PaymentDrawerModal, setW9RequestModal } from "./W8W9PaymentModalSlice";
import { all, put, takeLatest } from "redux-saga/effects";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import RecipientDataService from "../../../../../services/RecipientDataService";
import { PAGE_STATE } from "../../../constants/constants";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { REQUEST_TYPE_STATUS } from "../steps/getrequesttype/constants";
import { W8_W9_PAYMENT_MODAL_LOADING_STATES } from "./constants";

export const { isDisplayPlansView, getW8Forms, requestBulkW8, requestBulkW9 } = {
    isDisplayPlansView: (payload) => {
        return {
            type: "ADD_RECIPIENTS_NEW/IS_DISPLAY_PLANS_VIEW",
            payload
        }
    },

    getW8Forms: (payload) => {
        return {
            type: "ADD_RECIPIENTS_NEW/GET_W8_FORMS",
            payload
        }
    },

    requestBulkW8: (payload) => {
        return {
            type: "ADD_RECIPIENTS_NEW/REQUEST_BULK_W8",
            payload
        }
    },

    requestBulkW9: (payload) => {
        return {
            type: "ADD_RECIPIENTS_NEW/REQUEST_BULK_W9",
            payload
        }
    },

}

function* isDisplayPlansViewAsync(action) {
    try {
        yield put(setLoadingState({ state: W8_W9_PAYMENT_MODAL_LOADING_STATES.DISPLAY_PLANS_VIEW_LOADING }))

        const response = yield RecipientDataService.isDisplayPlansView();

        const { requestType } = action.payload

        const { Data, Message, Status } = response?.data;

        if (Status) {
            // if we have enought requests then deduct it from the request 
            if (Data) {
                if (requestType === REQUEST_TYPE_STATUS.W8REQUEST) {
                    yield put(setW8W9FormsModal(true))
                } else {
                    yield put(setW9RequestModal(true))
                }

                yield put(setHasEnoughRequests(true))
            } else {
                // else pay the amount using prepay/card
                yield put(setHasEnoughRequests(false))
                yield put(setW8W9PaymentDrawerModal(true))
            }
        } else {
            yield put(addNotifications({ heading: "Failed to get display plans", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get display plans", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: W8_W9_PAYMENT_MODAL_LOADING_STATES.DISPLAY_PLANS_VIEW_READY }))
    }

}

function* getW8FormsAsync() {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Loading..." }))

        const response = yield RecipientDataService.getW8Forms();

        const { Data, Status } = response?.data;

        if (Status) {
            const W8forms = Data.map(item => { return { value: item, label: item } })
            yield put(setW8Forms(W8forms))
        } else {
            yield put(addNotifications({ heading: "Failed to get W8 Forms" }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get W8 Forms", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }

}

function* requestBulkW8Async(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Loading..." }))

        const {
            RecipientIds = [],
            FormType = "W8-BEN",
            CommonCardHolderName = "",
            CommonCreditCardNumber = "",
            CommonCvvNumber = "",
            CommonExpiryMonth = "",
            CommonExpiryYear = "",
            TotalFee = "",
            Cardtype = "",
            Coupon = "",
            PrepaidAmount = "",
            commonisSaveCard = true,
            CommonSavedCard = null,
            w8W9PlanType = "",
            PaymentEmail = "",
            CommonBillingaddress = "",
            CommonCity = "",
            CommonZipcode = "",
            CommonState = "",
            CommonCountry = "",
            CommonContactEmail = "",
            isW8orW9Payment = "",
            IsBulkTin = "",
            totalAmount = "",
            prepay = "",
            showAdminAmount = "",
            saveCardId = "",
            saveCard = "",
            isPrepaid = "true",
            prepayless1 = "No",
            prepayFlag = "Yes",
            payerId = "",
            isAccountant = "true", // for prepay it is true otherwise false
            selectAll = "", // true if all are selected else false

            //below fields are not being used in the payload but these fields might be used in future
            payername = "",
            IsautorenewChecked = false,
            adminuserPayment = true,
            SalesTaxAmount = 10.99,
            FillingAmount = 20.99,
            w9PdfImportPrepayLbl = "Prepaid",
            TotalAmount = 100.99,
            planPlanType = "",
            CheckPrepay = "",
            TotalPrepayamount = "",
            IsPrepaid = true,
            StateCodes = null,
            isW8orW9Email = "",
            requestBalance = "",
            CountryCodes = null,
            HiddenTotalFee = "",
            AllSelected = true,
            IsNoticeChecked = true,
        } = action.payload

        const data = {
            RecipientIds,
            FormType,
            w8W9PlanType,
            isW8orW9Payment,
            CommonCardHolderName,
            CommonCreditCardNumber,
            CommonCvvNumber,
            CommonExpiryMonth,
            CommonExpiryYear,
            TotalFee,
            Cardtype,
            Coupon,
            PrepaidAmount,
            commonisSaveCard,
            CommonSavedCard,
            PaymentEmail,
            CommonBillingaddress,
            CommonCity,
            CommonZipcode,
            CommonState,
            CommonCountry,
            CommonContactEmail,
            IsBulkTin,
            totalAmount,
            prepay,
            showAdminAmount,
            saveCardId,
            saveCard,
            isPrepaid,
            prepayless1,
            prepayFlag,
            payerId,
            selectAll,
            isAccountant
        }

        const response = yield RecipientDataService.requestBulkW8(data);

        const { Status, Message } = response?.data;

        if (Status) {
            yield put(setW8W9FormsModal(false))
            yield put(addNotifications({ heading: "Success", message: "W8 request has been successfully sent.", variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }

}

function* requestBulkW9Async(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Loading..." }))

        const {
            RecipientIds,
            FormType = "W9",
            IsPrepaid = true,
            TotalAmount = 100.99,
            CommonCardHolderName = "",
            CommonCreditCardNumber = "",
            CommonCvvNumber = "",
            CommonExpiryMonth = "",
            CommonExpiryYear = "",
            TotalFee = "",
            Cardtype = "",
            Coupon = "",
            PrepaidAmount = "",
            commonisSaveCard = true,
            CommonSavedCard = null,
            w8W9PlanType = "",
            PaymentEmail = "",
            CommonBillingaddress = "",
            CommonCity = "",
            CommonZipcode = "",
            CommonState = "",
            CommonCountry = "",
            CommonContactEmail = "",
            StateCodes = null,
            isW8orW9Payment = "",
            isW8orW9Email = "",
            requestBalance = "",
            CountryCodes = null,
            HiddenTotalFee = "",
            IsBulkTin = "",
            planPlanType = "",
            CheckPrepay = "",
            TotalPrepayamount = "",
            totalAmount = "",
            prepay = "",
            showAdminAmount = "",
            saveCardId = "",
            saveCard = "",
            isPrepaid = "true",
            prepayless1 = "No",
            AllSelected = true,
            prepayFlag = "Yes",
            payerId = "",
            IsNoticeChecked = true,
            isAccountant = "true", // for prepay it is true otherwise false
            selectAll = "", // true if all are selected else false
            payername = "",
            IsautorenewChecked = false,
            adminuserPayment = true,
            SalesTaxAmount = 10.99,
            FillingAmount = 20.99,
            w9PdfImportPrepayLbl = "Prepaid"
        } = action.payload

        const data = {
            RecipientIds,
            FormType,
            w8W9PlanType,
            isW8orW9Payment,
            CommonCardHolderName,
            CommonCreditCardNumber,
            CommonCvvNumber,
            CommonExpiryMonth,
            CommonExpiryYear,
            TotalFee,
            Cardtype,
            Coupon,
            PrepaidAmount,
            commonisSaveCard,
            CommonSavedCard,
            PaymentEmail,
            CommonBillingaddress,
            CommonCity,
            CommonZipcode,
            CommonState,
            CommonCountry,
            CommonContactEmail,
            IsBulkTin,
            totalAmount,
            prepay,
            showAdminAmount,
            saveCardId,
            saveCard,
            isPrepaid,
            prepayless1,
            prepayFlag,
            payerId,
            selectAll,
            isAccountant
        }

        const response = yield RecipientDataService.requestBulkW9(data);

        const { Status, Message } = response?.data;

        if (Status) {
            yield put(setW9RequestModal(false))
            yield put(addNotifications({ heading: "Success", message: "W9 request has been successfully sent.", variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to send W9 request", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }

}

function* rootSaga() {
    yield all([
        takeLatest(isDisplayPlansView().type, isDisplayPlansViewAsync),
        takeLatest(getW8Forms().type, getW8FormsAsync),
        takeLatest(requestBulkW8().type, requestBulkW8Async),
        takeLatest(requestBulkW9().type, requestBulkW9Async),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);